module.exports = __webpack_public_path__ + "resource/img/account.7fe4806c.svg";